import styled from 'styled-components';
import { grid, justifyContent, justifyItems } from 'styled-system';

import { Box } from '@/components/Box';

import type { GridProps } from './Grid';

export const Grid = styled(Box)<GridProps>`
  display: grid;
  ${grid};
  ${justifyContent};
  ${justifyItems};
`;
